<template>
    <div>
        <example-description
                subject="ComponentTable 은 BaseTableLayout 에 미리 정의한 요소 컴포넌트 전달을 하는 역할을 합니다. slot 사용이 가능합니다."
                content="ComponentTable 은 headers 에 특정 컴포넌트를 지정하지 않을시 기본으로 td에는 TEXT 컴포넌트 th에는 TableTh 컴포넌트를 적용합니다."
        />
        <component-table
            :headers="headers"
            :items="items"
        >
        </component-table>

        <example-description
                subject="ComponentTable item.{key} slot 예제"
        />
        <component-table
            :headers="headers"
            :items="items"
        >
            <template #item.text>Component Table Item Text Slot</template>
        </component-table>

        <example-description
                subject="ComponentTable tabindex 예제"
                content="editable 이 true 일 때만 tabindex 가 있습니다."
        />
        <component-table
            :headers="headersEditable"
            :items="itemsEditable"
        >
        </component-table>

        <example-description
                subject="ComponentTable slot v-model binding"
        />
        <component-table
            :headers="headersEditable"
            :items="itemsEditable"
        >
            <template #item.text="{item, inputClass}">
                <v-btn :class="inputClass" @click="onClickBtn(item)">Click</v-btn>
            </template>
        </component-table>

        <example-description
                subject="ComponentTable 은 항상 fixedheader 입니다."
        />
        <div style="height: 400px;">
            <component-table
                    :headers="headersFixedHeader"
                    :items="itemsFixedHeader"
            >
            </component-table>
        </div>


        <example-description
                subject="Sorting & Search 예제"
        />
        <search-bar
            :placeholder="'검색어를 입력하세요.' | translate"
            reactivity="input"
            v-model="search"
            style="width: 450px; margin-top: 10px; margin-bottom: 5px"
        />
        <div style="height: 400px;">
            <component-table
                :headers="headersSorting"
                :items="itemsSorting"
                :search="search"
            >
            </component-table>
        </div>

    </div>
</template>

<script>
    import ExampleDescription from "@/components/example/ExampleDescription";
    import ComponentTable from "@/assets/plugins/mps-form-table/component/component-table/ComponentTable";
    import SearchBar from "@/components/input/SearchBar";
    import {RentalCompany} from "@/model/rental-company";

    export default {
        name: "ExampleComponentTable",
        components: {SearchBar, ComponentTable, ExampleDescription},
        data() {
            return {
                search: "",
                headers: [
                    {
                        text: "아이디",
                        key: "id",
                        width: "100px",
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: "300px",
                    },
                ],

                items: [
                    {
                        id: "test",
                        text: "테스트",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                    },
                ],

                headersColspan: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        children: [
                            {text: "col1", key: "cols1"},
                            {text: "col2", key: "cols2"},
                        ],
                    },
                ],

                itemsColspan: [
                    {
                        id: "test",
                        text: "테스트",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                    },
                ],

                headersEditable: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        editable: true,
                    },
                    {
                        text: "추가 내용",
                        key: "additional",
                        width: 300,
                        editable: true,
                    },
                ],

                itemsEditable: [
                    {
                        id: "test",
                        text: "테스트",
                        additional: "추가 내용 1",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                        additional: "추가 내용 2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                        additional: "추가 내용 3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                        additional: "추가 내용 4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                        additional: "추가 내용 5",
                    },
                ],

                headersFixedHeader: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        editable: true,
                    },
                    {
                        text: "마지막 컬럼인 추가 내용은 window width 를 줄일시 헤더가 내려갑니다. window 사이즈를 조정해 보세요",
                        key: "additional",
                        width: 300,
                        editable: true,
                    },
                    {
                        text: "마지막 컬럼인 추가 내용은 window width 를 줄일시 헤더가 내려갑니다. window 사이즈를 조정해 보세요",
                        key: "additional2",
                        width: 300,
                        editable: true,
                    },
                ],

                itemsFixedHeader: [
                    {
                        id: "test",
                        text: "테스트",
                        additional: "추가 내용 1",
                        additional2: "추가 내용 1",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                        additional: "추가 내용 2",
                        additional2: "추가 내용 2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                        additional: "추가 내용 3",
                        additional2: "추가 내용 3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                        additional: "추가 내용 4",
                        additional2: "추가 내용 4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                        additional: "추가 내용 5",
                        additional2: "추가 내용 5",
                    },
                    {
                        id: "test",
                        text: "테스트",
                        additional: "추가 내용 1",
                        additional2: "추가 내용 1",
                    },
                    {
                        id: "test2",
                        text: "테스트2",
                        additional: "추가 내용 2",
                        additional2: "추가 내용 2",
                    },
                    {
                        id: "test3",
                        text: "테스트3",
                        additional: "추가 내용 3",
                        additional2: "추가 내용 3",
                    },
                    {
                        id: "test4",
                        text: "테스트4",
                        additional: "추가 내용 4",
                        additional2: "추가 내용 4",
                    },
                    {
                        id: "test5",
                        text: "테스트5",
                        additional: "추가 내용 5",
                        additional2: "추가 내용 5",
                    },
                ],

                headersSorting: [
                    {
                        text: "아이디",
                        key: "id",
                        width: 100,
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "내용",
                        key: "text",
                        width: 300,
                        editable: true,
                        sortable: true,
                        filterable: true,
                    },
                    {
                        text: "마지막 컬럼인 추가 내용은 window width 를 줄일시 헤더가 내려갑니다. window 사이즈를 조정해 보세요",
                        key: "additional",
                        width: 300,
                        editable: true,
                    },
                    {
                        text: "마지막 컬럼인 추가 내용은 window width 를 줄일시 헤더가 내려갑니다. window 사이즈를 조정해 보세요",
                        key: "additional2",
                        width: 300,
                    },
                ],

                itemsSorting: [
                ],
            }
        },
        created() {
            const items = [];
            for (let i = 1; i < 51; i++) {
                items.push({
                    id: i,
                    text: "text" + i,
                    additional: "additinal" + i,
                    additional2: "additinal2-" + i
                })
            }
            this.itemsSorting = items;
        },
        methods: {
            onClickBtn(item) {
                alert(item.text);
            },
        },
    }
</script>

<style scoped>

</style>